import { render } from "./SplashPage.vue?vue&type=template&id=40327ec6&scoped=true"
import script from "./SplashPage.vue?vue&type=script&lang=js"
export * from "./SplashPage.vue?vue&type=script&lang=js"

import "./SplashPage.vue?vue&type=style&index=0&id=40327ec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40327ec6"]])

export default __exports__